import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_SLOT_FILL_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
import { formURL } from "Utils/CommonUtilities";

export default class FillApplicationSlot extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    applicantId: "",
  };

  url = APPLICATION_SLOT_FILL_URL;

  constructor(reqData) {
    super();
    console.log(reqData);

    this.body = reqData;

    const { slotId, applicationId } = reqData;
    let paramList = [applicationId, slotId];
    this.url = formURL(this.url, paramList);
    console.log(this.url);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
